import React from 'react';
import PropTypes from 'prop-types';
import Table from '../common/table';

import {
  StyledTableCell,
  StyledStatus,
  StyledInlineButton,
} from './style';

const InvitationRow = ({ showResendCta, invitation, onResendClick }) => (
  <Table.Row hover>
    <StyledTableCell>
      {invitation.key}
    </StyledTableCell>
    <StyledTableCell>
      <StyledStatus>
        {invitation.status}
      </StyledStatus>
    </StyledTableCell>
    <StyledTableCell>
      {showResendCta &&
        <StyledInlineButton onClick={onResendClick}>Resend</StyledInlineButton>
      }
    </StyledTableCell>
    <StyledTableCell colSpan={2}>
      {invitation.receiverRole}
    </StyledTableCell>
  </Table.Row>
);

InvitationRow.propTypes = {
  invitation: PropTypes.shape({
    key: PropTypes.string,
    status: PropTypes.string,
    receiverRole: PropTypes.string,
  }).isRequired,
  showResendCta: PropTypes.bool,
  onResendClick: PropTypes.func,
};

InvitationRow.defaultProps = {
  showResendCta: false,
  onResendClick: () => {},
};

export default InvitationRow;
